import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";

import { FormButtons, TailwindModal } from "../components";
import { useStore } from "../helpers";
import { FTPAutoComplete } from "../components-new";
import { toJS } from "mobx";
import { exists } from "i18next";
import { safe_get } from "../report-visuals";
import { toast } from "react-toastify";

export const AddSkipQuestion = observer((props) => {
    // @ts-ignore
    const { handleSave, currentQuestion } = props;
    const rootStore = useStore();
    const methods = useForm({});
    const { projectStore } = rootStore;
    const [isReady, setIsReady] = useState(false);
    const reset = () => {
        methods.setValue("question_key", null);
        methods.setValue("qvalue", []);
    };
    const onSubmit = (values: any) => {
        try {
            const other_languages = {};
            const selected_option_index = values?.["qvalue"]?.map((q_value) => {
                return projectStore.question_options_map[values?.["qkey"]]?.[
                    "en"
                ]?.findIndex((opt) => opt === q_value);
            });
            // console.log("selected index", selected_option_index);
            Object.keys(
                projectStore.question_options_map[values?.["qkey"]]
            ).map((key) => {
                other_languages[key] = [
                    ...selected_option_index.map(
                        (idx) =>
                            projectStore.question_options_map[values?.["qkey"]][
                                key
                            ][idx]
                    ),
                ];
            });
            // console.log(other_languages);
            const ingest_payload = {
                payload: {
                    entry_condition: {
                        exists: true,
                        qkey: values?.["qkey"],
                        qvalue: {
                            ...other_languages,
                        },
                    },
                },
            };

            const final_question_with_condition = safe_get(
                currentQuestion,
                "payload",
                false
            )
                ? {
                      ...toJS(currentQuestion),
                      payload: {
                          ...toJS(currentQuestion.payload),
                          ...ingest_payload.payload,
                      },
                  }
                : { ...toJS(currentQuestion), ...ingest_payload };
            // console.log(ingest_payload, "ingest_payload");
            // console.log(toJS(currentQuestion), "current question");
            // console.log(
            //   final_question_with_condition,
            //   "final question with condition"
            // );
            projectStore.set_current_question(final_question_with_condition);
            handleSave(JSON.stringify(final_question_with_condition));
            projectStore.show_skip_modal(false);
            toast.success("added condition");
        } catch (error) {
            console.log(error);
            toast.error("something went wrong");
        }
    };

    const question_key = methods.watch("qkey");
    useEffect(() => {
        projectStore.set_options([]);
        setIsReady(false);
        try {
            if (question_key) {
                projectStore.set_options([
                    ...toJS(
                        projectStore.question_options_map?.[question_key]?.[
                            "en"
                        ]
                    ),
                ]);
                methods.setValue("qvalue", []);
            }
        } catch (error) {
            console.log(error);
        }
    }, [question_key]);

    useEffect(() => {
        if (projectStore.options.length > 0) setIsReady(true);
    }, [projectStore.options]);
    const prefilled_current_payload = safe_get(
        currentQuestion,
        "payload.entry_condition.exists",
        false
    )
        ? {
              qkey: currentQuestion?.payload?.entry_condition?.qkey,
              qvalue: currentQuestion?.payload?.entry_condition?.qvalue?.en,
          }
        : null;

    useEffect(() => {
        if (prefilled_current_payload) {
            methods.setValue("qkey", prefilled_current_payload.qkey);
        } else {
            methods.setValue("qkey", "");
            methods.setValue("qvalue", []);
        }
    }, [currentQuestion]);

    useEffect(() => {
        if (
            prefilled_current_payload?.qkey === methods.watch("qkey") &&
            Array.isArray(prefilled_current_payload?.qvalue) &&
            prefilled_current_payload.qvalue.length > 0
        ) {
            methods.setValue("qvalue", [...prefilled_current_payload.qvalue]);
        }
    }, [methods.watch("qkey"), currentQuestion]);
    return (
        <>
            <TailwindModal isOpen={projectStore.skipModal}>
                <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-lg w-full">
                    <FormProvider {...methods}>
                        <form
                            onSubmit={methods.handleSubmit(onSubmit)}
                            className="bg-white px-4 py-2 rounded-sm flex flex-col gap-y-4"
                        >
                            <FTPAutoComplete
                                data={projectStore.question_key_list}
                                label="Question Key"
                                name="qkey"
                                placeholder="question_key"
                            />
                            {question_key &&
                                projectStore.options.length > 0 &&
                                isReady && (
                                    <FTPAutoComplete
                                        key={question_key}
                                        data={projectStore.options}
                                        label="Question Options"
                                        name="qvalue"
                                        placeholder="question_options"
                                        multiple={true}
                                    />
                                )}
                            <button
                                className="bg-red-400 p-2 text-white rounded-xl"
                                type="button"
                                onClick={() => reset()}
                            >
                                Remove
                            </button>
                            <FormButtons
                                onSave={() => {}}
                                onCancel={() => {
                                    projectStore.show_skip_modal(false);
                                }}
                                type={"submit"}
                            />
                        </form>
                    </FormProvider>
                </div>
            </TailwindModal>
        </>
    );
});
